<template>
  <router-link 
  	v-if="broker != null"
    :to="{ name: $store.state.view == 'client' ? 'client-home' : 'broker-home' }" 
    tag="a" 
    class="overflow-hidden block no-underline">
    <img :src="broker.logo.url" 
    	:style="'vertical-align: middle;max-height:' + height + ';max-width:' + width + ';'"
    	class="inline" />
  </router-link>
</template>

<script>
	export default {
		props : {
			broker : {
				type    : Object,
				required: true
			},

      width : {
        type    : String,
        required: false,
        default : '150px'
      },

      height : {
        type    : String,
        required: false,
        default : '80px'
      }
		}
	}
</script>